/* eslint-disable camelcase */
/**
 *  Do not edit this file! It is autogenerated from the harmony composerasdfsad
 */
import {
  withLayout,
  withLayoutAccordion,

} from '@thd-olt-component-react/fusion-utils';

import { RulesMiddleware as RulesMiddleware_MiddlewareSlot
  , withExpContextRule } from '@thd-olt-component-middleware/pip';

import { PIPRedirector }
from '@thd-nucleus/app-render';

import { ProductMetadata }
from '@thd-olt-component-react/metadata';

import { Breadcrumbs }
from '@thd-olt-component-react/breadcrumbs';

import { PIPSharebelt }
from '@thd-olt-component-react/thd-sharebelt';

import { ConnectedTranslatorWidget }
from '@thd-olt-component-react/translator_widget';

import { DynamicRecsWrapperPip, RecentlyViewedWrapper }
from '@thd-olt-component-react/thd-recs-containers';

import { Discontinued }
from '@thd-olt-component-react/discontinued';

import { PIPProductDetails }
from '@thd-olt-component-react/product-details';

import { MediaGalleryWithHotspotsCarousel }
from '@thd-olt-component-react/media-gallery';

import { RoomVo, RoomVoInspire, BathRenovation }
from '@thd-olt-component-react/augmented-reality';

import { ProductPageEventCountdownTimer }
from '@thd-olt-component-react/event-countdown-timer';

import { PromotionUrgencyMessaging, Promotion }
from '@thd-olt-component-react/promotion';

import { PIPPriceClearanceWrapper }
from '@thd-olt-component-react/price';

import { PromotionProductsAnchor }
from '@thd-olt-component-react/promotion-products';

import { CalcLink }
from '@thd-olt-component-react/moving-calculator';

import { ConfiguratorAndPipFlipLayout }
from '@thd-olt-component-react/product-configurator';

import { BuyboxWithPIPCalculator }
from '@thd-olt-component-react/buybox';

import { BundlePmvFbtLayoutGmAndHdh }
from '@thd-olt-component-react/bundle-mini';

import { ProductInfoBar }
from '@thd-olt-component-react/product-info-bar';

import { ProductOverviewAccordionTitle }
from '@thd-olt-component-react/product-overview';

import { SpecificationsAccordionTitle }
from '@thd-olt-component-react/specifications';

import { QuestionsAndAnswersAccordionTitle }
from '@thd-olt-component-react/questions-and-answers';

import { RatingsAndReviewsAccordionTitle }
from '@thd-olt-component-react/ratings-and-reviews';

import { BazaarVoiceCarousel }
from '@thd-olt-component-react/social-media-container';

import { SponsoredPipBanner }
from '@thd-olt-component-react/sponsored-content';

import { EducationalSummary }
from '@thd-olt-component-react/educational-summary';

import { RetailMediaCarouselFusionPIP }
from '@thd-olt-component-react/retail-media-pla-sponsored-placements';

import { FeatureBasedRecommendationsImporter }
from '@thd-olt-component-react/feature-based-recommendations';

import { TextAnExpert }
from '@thd-olt-component-react/text-an-expert';

import { RelatedSearch, PopularVariations }
from '@thd-olt-component-react/related-search';

import { EmtLinks }
from '@thd-olt-component-react/emt-links';

import { DigitalTicket }
from '@thd-olt-component-react/digital-ticket';

export { PIPRedirector };

export { ProductMetadata };

export { Breadcrumbs };

export { PIPSharebelt };

export { ConnectedTranslatorWidget };

export { DynamicRecsWrapperPip };

export { Discontinued };

export { PIPProductDetails };

export { MediaGalleryWithHotspotsCarousel };

export { RoomVo };

export { ProductPageEventCountdownTimer };

export { PromotionUrgencyMessaging };

export { PIPPriceClearanceWrapper };

export { Promotion };

export { PromotionProductsAnchor };

export { CalcLink };

export { ConfiguratorAndPipFlipLayout };

export { BuyboxWithPIPCalculator };

export { BundlePmvFbtLayoutGmAndHdh };

export { ProductInfoBar };

export { ProductOverviewAccordionTitle };

export { SpecificationsAccordionTitle };

export { QuestionsAndAnswersAccordionTitle };

export { RatingsAndReviewsAccordionTitle };

export { BazaarVoiceCarousel };

export { RoomVoInspire };

export { BathRenovation };

export { SponsoredPipBanner };

export { EducationalSummary };

export { RetailMediaCarouselFusionPIP };

export { FeatureBasedRecommendationsImporter };

export { TextAnExpert };

export { RecentlyViewedWrapper };

export { RelatedSearch };

export { PopularVariations };

export { EmtLinks };

export { DigitalTicket };

const SlotA1 = withLayout(
  [

    PIPRedirector,

  ],

);

const SlotA2 = withLayout(
  [

    ProductMetadata,

  ],

);

const SlotB1 = withLayout(
  [

    Breadcrumbs,

  ],

);

const SlotC1 = withLayout(
  [

    PIPSharebelt,

  ],

);

const SlotC2 = withLayout(
  [

    ConnectedTranslatorWidget,

  ],

);

const SlotD1 = withLayout(
  [

    Breadcrumbs,

  ],

);

const SlotD2 = withLayout(
  [

    DynamicRecsWrapperPip,

  ],

);

const SlotD3 = withLayout(
  [

    Discontinued,

  ],

);

const SlotE1 = withLayout(
  [

    PIPProductDetails,

  ],

);

const SlotE2 = withLayout(
  [

    MediaGalleryWithHotspotsCarousel,

  ],

);

const SlotE3 = withLayout(
  [

    RoomVo,

  ],

);

const SlotF1 = withLayout(
  [

    ProductPageEventCountdownTimer,

  ],

);

const SlotF2 = withLayout(
  [

    PromotionUrgencyMessaging,

  ],

);

const SlotF4 = withLayout(
  [

    PIPPriceClearanceWrapper,

  ],

);

const SlotF5 = withLayout(
  [

    Promotion,

  ],

);

const SlotF8 = withLayout(
  [

    PromotionProductsAnchor,

  ],

);

const SlotF10 = withLayout(
  [

    CalcLink,

  ],

);

const SlotF13 = withLayout(
  [

    ConfiguratorAndPipFlipLayout,

  ],

);

const SlotF15 = withLayout(
  [

    BuyboxWithPIPCalculator,

  ],

);

const SlotG1 = withLayout(
  [

    DynamicRecsWrapperPip,

  ],

);

const SlotG2 = withLayout(
  [

    BundlePmvFbtLayoutGmAndHdh,

  ],

);

const SlotG3 = withLayout(
  [

    DynamicRecsWrapperPip,

  ],

);

const SlotG4 = withLayout(
  [

    DynamicRecsWrapperPip,

  ],

);

const SlotG5 = withLayout(
  [

    ProductInfoBar,

  ],

);

const SlotG9 = withLayout(
  [

    BazaarVoiceCarousel,

  ],

);

const SlotG10 = withLayout(
  [

    RoomVoInspire,

  ],

);

const SlotG11 = withLayout(
  [

    BathRenovation,

  ],

);

const SlotG12 = withLayout(
  [

    DynamicRecsWrapperPip,

  ],

);

const SlotG13 = withLayout(
  [

    DynamicRecsWrapperPip,

  ],

);

const SlotG14 = withLayout(
  [

    SponsoredPipBanner,

  ],

);

const SlotG15 = withLayout(
  [

    EducationalSummary,

  ],

);

const SlotG16 = withLayout(
  [

    DynamicRecsWrapperPip,

  ],

);

const SlotG17 = withLayout(
  [

    DynamicRecsWrapperPip,

  ],

);

const SlotG18 = withLayout(
  [

    DynamicRecsWrapperPip,

  ],

);

const SlotG19 = withLayout(
  [

    DynamicRecsWrapperPip,

  ],

);

const SlotG20 = withLayout(
  [

    DynamicRecsWrapperPip,

  ],

);

const SlotG21 = withLayout(
  [

    DynamicRecsWrapperPip,

  ],

);

const SlotG22 = withLayout(
  [

    RetailMediaCarouselFusionPIP,

  ],

);

const SlotG23 = withLayout(
  [

    FeatureBasedRecommendationsImporter,

  ],

);

const SlotG24 = withLayout(
  [

    DynamicRecsWrapperPip,

  ],

);

let RulesMiddleware_MiddlewareSlot_G25 = RulesMiddleware_MiddlewareSlot;

RulesMiddleware_MiddlewareSlot_G25 = withExpContextRule(RulesMiddleware_MiddlewareSlot_G25, { render: { name: 'isConsumerApp', negate: true } });

const SlotG25 = withLayout(
  [

    TextAnExpert,

  ],

  RulesMiddleware_MiddlewareSlot_G25

);

const SlotG26 = withLayout(
  [

    RecentlyViewedWrapper,

  ],

);

const SlotG27 = withLayout(
  [

    RelatedSearch,

  ],

);

const SlotG28 = withLayout(
  [

    PopularVariations,

  ],

);

const SlotG29 = withLayout(
  [

    EmtLinks,

  ],

);

const SlotG30 = withLayout(
  [

    DigitalTicket,

  ],

);

const ssr = typeof window === 'undefined';

const SlotF3Index0DataModel = ssr
  ? __webpack_require__(require.resolveWeak('@thd-olt-component-react/augmented-reality'))
    .AugmentedReality
  : {};

const SlotF6Index0DataModel = ssr
  ? __webpack_require__(require.resolveWeak('@thd-olt-component-react/disclaimer-message'))
    .DisclaimerMessage
  : {};

const SlotF7Index0DataModel = ssr
  ? __webpack_require__(require.resolveWeak('@thd-olt-component-react/consumer-card-messaging'))
    .ConsumerCardMessaging
  : {};

const SlotF9Index0DataModel = ssr
  ? __webpack_require__(require.resolveWeak('@thd-olt-component-react/global-custom-configurator'))
    .GlobalCustomConfigurator
  : {};

const SlotF11Index0DataModel = ssr
  ? __webpack_require__(require.resolveWeak('@thd-olt-component-react/aisle-bay'))
    .AisleBay
  : {};

const SlotF12Index0DataModel = ssr
  ? __webpack_require__(require.resolveWeak('@thd-olt-component-react/super-sku'))
    .SuperSku
  : {};

const SlotF14Index0DataModel = ssr
  ? __webpack_require__(require.resolveWeak('@thd-olt-component-react/order-sample'))
    .OrderSample
  : {};

const SlotF16Index0DataModel = ssr
  ? __webpack_require__(require.resolveWeak('@thd-olt-component-react/returns-messaging'))
    .ReturnsMessaging
  : {};

const SlotG6Index0DataModel = ssr
  ? __webpack_require__(require.resolveWeak('@thd-olt-component-react/magic-apron'))
    .BotPrompt
  : {};

const SlotG7Index0DataModelK0 = ssr
  ? __webpack_require__(require.resolveWeak('@thd-olt-component-react/product-overview'))
    .ProductOverviewAccordionTitle
  : {};

const SlotG7Index0DataModelBodyK0 = ssr
  ? __webpack_require__(require.resolveWeak('@thd-olt-component-react/product-overview'))
    .ProductOverviewAccordionBody
  : {};

const SlotG7Index1DataModelK0 = ssr
  ? __webpack_require__(require.resolveWeak('@thd-olt-component-react/specifications'))
    .SpecificationsAccordionTitle
  : {};

const SlotG7Index1DataModelBodyK0 = ssr
  ? __webpack_require__(require.resolveWeak('@thd-olt-component-react/specifications'))
    .SpecificationsAccordionBody
  : {};

const SlotG7Index2DataModelK0 = ssr
  ? __webpack_require__(require.resolveWeak('@thd-olt-component-react/questions-and-answers'))
    .QuestionsAndAnswersAccordionTitle
  : {};

const SlotG7Index2DataModelBodyK0 = ssr
  ? __webpack_require__(require.resolveWeak('@thd-olt-component-react/questions-and-answers'))
    .QuestionsAndAnswersAccordionBody
  : {};

const SlotG7Index3DataModelK0 = ssr
  ? __webpack_require__(require.resolveWeak('@thd-olt-component-react/ratings-and-reviews'))
    .RatingsAndReviewsAccordionTitle
  : {};

const SlotG7Index3DataModelBodyK0 = ssr
  ? __webpack_require__(require.resolveWeak('@thd-olt-component-react/ratings-and-reviews'))
    .RatingsAndReviewsAccordionBody
  : {};

const SlotG8Index0DataModel = ssr
  ? __webpack_require__(require.resolveWeak('@thd-olt-component-react/magic-apron'))
    .BotPrompt
  : {};

export {

  SlotA1,

  SlotA2,

  SlotB1,

  SlotC1,

  SlotC2,

  SlotD1,

  SlotD2,

  SlotD3,

  SlotE1,

  SlotE2,

  SlotE3,

  SlotF1,

  SlotF2,

  SlotF4,

  SlotF5,

  SlotF8,

  SlotF10,

  SlotF13,

  SlotF15,

  SlotG1,

  SlotG2,

  SlotG3,

  SlotG4,

  SlotG5,

  SlotG9,

  SlotG10,

  SlotG11,

  SlotG12,

  SlotG13,

  SlotG14,

  SlotG15,

  SlotG16,

  SlotG17,

  SlotG18,

  SlotG19,

  SlotG20,

  SlotG21,

  SlotG22,

  SlotG23,

  SlotG24,

  SlotG25,

  SlotG26,

  SlotG27,

  SlotG28,

  SlotG29,

  SlotG30,

  SlotF3Index0DataModel,

  SlotF6Index0DataModel,

  SlotF7Index0DataModel,

  SlotF9Index0DataModel,

  SlotF11Index0DataModel,

  SlotF12Index0DataModel,

  SlotF14Index0DataModel,

  SlotF16Index0DataModel,

  SlotG6Index0DataModel,

  SlotG7Index0DataModelK0,

  SlotG7Index0DataModelBodyK0,

  SlotG7Index1DataModelK0,

  SlotG7Index1DataModelBodyK0,

  SlotG7Index2DataModelK0,

  SlotG7Index2DataModelBodyK0,

  SlotG7Index3DataModelK0,

  SlotG7Index3DataModelBodyK0,

  SlotG8Index0DataModel,

};
